<template lang="html">
    <div class="paginate-block theme-default" v-if="totalPage&&theme!='oldtheme'"> 
        <div class="pagination" >
            <template v-if="totalPage > 1">
            <a v-if="withNextPrev" class="prev-btn" :class="disablePrev" @click="!disablePrev ? btnPrev() : ''">
                {{ prevText }}
            </a>
            <span class="page-text">{{ currentPage }}/{{ totalPage }}</span>
            <a v-if="withNextPrev" class="next-btn" :class="disableNext" @click="!disableNext ? btnNext() : ''">
                {{ nextText }}
            </a>
            跳到
            <div class="pages-select">
                <input type="text" v-model=selected>
            </div>
            <a class="go-btn" @click="emitBtnClick(selected)">GO</a>
            </template>
            <template v-if="totalPage==1">
                共
                <span class="page-text">{{ currentPage }}/{{ totalPage }}</span>
                页
            </template>
        </div>
    </div>
    <div class="paginate-block theme2" v-else-if="totalPage&&theme=='oldtheme'">     
        <div class="pagination">
            <a v-if="withNextPrev" class="prev-btn" :class="disablePrev" @click="!disablePrev ? btnPrev() : ''">
                <span class="icons" :class="[disablePrev?'icon-prev-disabled':'icon-prev']"></span>
            </a>
            <div class="pages">
                <span class="page-text" @click.stop="showPages">{{ currentPage }}</span>
                <div  class="page-list" v-bar :style="{'top':totalPage>=6?'-176px':-totalPage*30+4+'px'}">
                <div>
                <ul  v-show=listShow>
                    <li  v-for="item in totalPage" :key=item @click="btnClick(item)" :class="{'active':currentPage==item}">{{item}}</li>
                </ul>
                </div>
                </div>
            </div>
            <a v-if="withNextPrev" class="next-btn" :class="disableNext" @click="!disableNext ? btnNext() : ''">
                <span class="icons" :class="[disableNext?'icon-next-disabled':'icon-next']"></span>                
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name : 'Paginate',
        props : {
            totalRecord:{
                type : Number,
                required: true
            },
            perPage:{
                type : Number,
                default: 10
            },
            withNextPrev : {
                type : Boolean,
                default : true
            },
            nextText : {
                type : String,
                default : '下一页'
            },
            prevText : {
                type : String,
                default : '上一页'
            },
            current : [Number,String],
            theme : {
                type: String,
                default: 'oldtheme'
            }
        },
        data() {
            return {
                currentPage: this.current||1,
                selected: '',
                totalPage: Math.ceil(this.totalRecord/this.perPage),
                disableNext : '',
                disablePrev : '',
                listShow:false
            }
        },
        created(){
            $('body').on('click',()=>{
                this.listShow=false
            })
        },
        watch:{
            totalRecord (val,oldVal) {
                // this.currentPage = 1
                this.totalRecord = val
                this.totalPage = Math.ceil(this.totalRecord/this.perPage)
                this.disablePrevNext()
                if(this.totalPage>0&&this.currentPage>this.totalPage){
                    this.$emit('btnClick', 1)                    
                }
            },
            current(val,oldVal){
                this.currentPage = val
                this.disablePrevNext()                
            },
            perPage (val,oldVal) {
                this.perPage = val
                this.totalPage = Math.ceil(this.totalRecord/this.perPage)                
            }
        },
        mounted()
        {
            this.disablePrevNext()
        },
        methods : {
            emitBtnClick : function(n)
            {
                if(!Number.isInteger(Number(n))){
                    this.$toast({
                      message:'请输入整数',
                      theme:'warning'  
                    })
                    this.selected=''
                    return
                }
                if(n > this.totalPage){
                    this.$toast({
                      message:'页数不能大于'+this.totalPage,
                      theme:'warning'  
                    })
                    return
                }else if(n < 1){
                    this.$toast({
                      message:'页数必须大于0',
                      theme:'warning'  
                    })
                    return
                }
                // this.currentPage = n
                this.$emit('btnClick', n)
                this.disablePrevNext()
                this.selected = ''
            },
            showPages:function(){
                this.listShow=true
                setTimeout(()=>{$('.page-list .vb-content').scrollTop((this.currentPage-1)*30)  },0 )              
            },
            btnClick : function(n)
            {
                this.$emit('btnClick', n)
                this.disablePrevNext()
                this.listShow=false
            },
            btnNext : function()
            {
                this.currentPage++;
                this.$emit('btnClick', this.currentPage)
                this.disablePrevNext()
            },

            btnPrev : function()
            {
                this.currentPage--
                this.$emit('btnClick', this.currentPage)
                this.disablePrevNext()
            },

            disablePrevNext : function()
            {
                this.disablePrev = this.currentPage == 1 ? 'disabled' : ''
                this.disableNext = this.currentPage == this.totalPage ? 'disabled' : ''              
                // this.disableNext = this.currentPage != 1 && this.currentPage == this.totalPage ? 'disabled' : ''
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '../../assets/style/variables';
    .paginate-block {
        position: fixed;
        width: calc(100% - 200px);
        background: #fff;
        z-index: 1;
        bottom: 0;
        text-align: right;
        font-size: 14px;
        line-height: 50px;
        // padding-right: 30px;
        border-top: 1px solid #d0d0d0;  
        &.theme2{
            text-align: center;
            line-height: 30px;
        }
        
    }
    .theme2 .pagination{
        font-size:12px;
        color: $dark-gray-color; 
        a:not(.disabled):hover {
            cursor: pointer;
            color:#457EEC;  
        }
        .pages{
            display: inline-block;
            position: relative;
            width: 50px;            
        }
        .page-text{
            display: inline-block;
            width: 100%;
            text-align: left;
            margin: 0 4px;
            padding-left: 10px;
            position: relative;
            cursor: pointer;
            &:after{
                content:'';
                position: absolute;
                top:12px;
                // right:4px;
                margin-left: 6px;
                width: 0;
                height:0;
                border:4px solid;
                border-top-width:6px;
                border-color:#ccc transparent transparent transparent;
            }
        }
        .page-list{
            position: absolute !important;
            left:0;
            top:-180px;
            background: #fff;
            width: 100%;
            text-align:center;
            line-height: 30px;
            z-index:2;
            border-radius: 2px;
            overflow: hidden;
            box-shadow: 2px 2px 6px 0 rgba(0,0,0,0.4);
            // overflow: auto;
            ul{
                max-height:180px;
            }
            li:hover{
              background: #F3F3F3; 
              cursor: pointer; 
            }
            .active{
              background: #F3F3F3;  
            }
            
        }
        .next-btn{
            margin-right: 30px;
        }
    }


    .theme-default .pagination{
        font-size:12px;
        color: $dark-gray-color; 
        .pages-select{
            display: inline-block;
            position: relative;
            input{
                display: inline-block;
                text-align: center;
                width:30px;
                height:22px; 
                color: $dark-gray-color;;
                border-radius: 2px; 
                border:1px solid #e8e8e8;
                padding: 2px 6px;
                &:hover{
                    border:1px solid $dark-gray-color;  
                }
            }
            .page-list{
                position: absolute;
                top: -60px;
                width: 30px;
                max-height: 60px;
                overflow-y: auto;
                line-height: 22px;
                text-align: center;
                border:1px solid $dark-gray-color;            
            }
            
        }
        a:not(.disabled):hover {
            cursor: pointer;
            color:#457EEC;  
        }
        .page-text{
            margin: 0 4px;
        }
        .next-btn{
            margin-right: 30px;
        }
        .go-btn{
            display: inline-block;
            width:30px;
            height:22px; 
            line-height: 22px;
            text-align:center;
            border-radius: 2px ; 
            border:1px solid #e8e8ee;
            &:hover{
                border-color:#457EEC;
                border:1px solid #457EEC;
                
            }
        }
    }

</style>
<style>
.vb-dragger-styler{
    background-color: rgba(0,0,0,0.4) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/paginate/paginate.vue